module.exports = __webpack_public_path__ + "fonts/WorkSans-ExtraBold.780fcdc.ttf";